// extracted by mini-css-extract-plugin
export const donateSection = "donate-module--donateSection--r63tm";
export const donateBackgroundImageContainer = "donate-module--donateBackgroundImageContainer--2zu49";
export const donateBackgroundImage = "donate-module--donateBackgroundImage--18htt";
export const donateContent = "donate-module--donateContent--dFM6c";
export const donateMessage = "donate-module--donateMessage--2HVsF";